var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3584.8271,
    y1: 4029.876,
    x2: 1142.4052,
    y2: 996.5412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2912.765,2833.758c-56.047,59.003-109.077,97.054-150.976,127.117 c-492.509,353.381-1075.278,250.372-1199.134,225.216c-182.895-37.147-535.395-109.831-792.024-409.528 c-378.042-441.484-295.033-1123-26.532-1644.124c46.916-91.061,344.678-566.645,933.724-643.644 c356.484-46.599,772.031,47.386,1072.958,299.503C3382.454,1317.515,3337.485,2386.625,2912.765,2833.758z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2697.675,2830.017c38.745-5.655,57.532-50.54,34.482-82.192 C2522.569,2460.023,1670.666,1346.88,713.134,884.595c-74.238-35.841-162.691,24.515-155.701,106.535 C603.472,1531.337,892.383,3093.521,2697.675,2830.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#FFFFFF"
    },
    d: "M2584.245,2780.125c5.301,2.146,2.338,10.049-3.236,8.635 c-205.495-52.15-1045.992-375.68-1706.786-1423.679c-2.122-3.366,2.909-6.971,5.327-3.808 C1057.691,1594.273,1745.997,2440.931,2584.245,2780.125z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1189.795,477.548c-23.906,288.549-94.45,1973.422,1474.717,2323.618 c0,0,331.981-1097.259-1436.25-2341.689C1212.793,448.589,1191.356,458.697,1189.795,477.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#FFFFFF"
    },
    d: "M1343.931,724.244c26.238,91.82,56.055,182.408,87.264,272.555 c31.375,90.079,64.781,179.449,99.997,268.105c35.156,88.681,72.541,176.482,111.841,263.42l14.699,32.62l15.174,32.403 l15.193,32.396c5.018,10.821,10.142,21.592,15.443,32.277l31.438,64.295l32.524,63.759 c10.674,21.341,22.175,42.252,33.371,63.323c11.255,21.04,22.376,42.154,34.231,62.87l35.105,62.396l36.398,61.663l9.1,15.416 l9.428,15.219l18.928,30.397l18.929,30.397c6.242,10.176,13.047,19.993,19.544,30.008c13.186,19.905,26.173,39.945,39.524,59.741 l41.086,58.696l10.273,14.674l10.691,14.376l21.435,28.715l21.437,28.716c7.136,9.579,14.833,18.731,22.223,28.117l22.388,27.994 l11.195,13.997c3.716,4.678,7.436,9.354,11.402,13.828l46.804,54.339c63.683,71.336,131.392,139.191,204.116,201.586 c3.448,2.958,8.64,2.561,11.598-0.887c2.958-3.448,2.561-8.64-0.887-11.598l-0.025-0.022l-0.084-0.072 c-72.277-61.501-139.748-128.544-203.31-199.15l-46.738-53.808c-3.961-4.429-7.678-9.063-11.393-13.701l-11.189-13.874 l-22.38-27.749c-7.389-9.306-15.083-18.373-22.222-27.876l-21.449-28.487l-21.451-28.489l-10.701-14.263l-10.287-14.568 l-41.154-58.276c-13.379-19.661-26.399-39.571-39.617-59.345c-6.513-9.951-13.334-19.701-19.596-29.816l-18.989-30.214 l-18.99-30.214l-9.46-15.13l-9.135-15.33l-36.541-61.324l-35.265-62.076c-11.909-20.608-23.087-41.624-34.401-62.564 c-11.254-20.972-22.815-41.783-33.552-63.031l-32.714-63.479l-31.638-64.03c-5.334-10.642-10.493-21.37-15.545-32.149 l-15.298-32.271l-15.28-32.28l-14.808-32.501c-39.589-86.62-77.279-174.128-112.752-262.535 c-35.532-88.382-69.264-177.498-100.973-267.332c-31.533-89.869-61.719-180.33-88.245-271.726l-0.018-0.06 c-0.536-1.848-2.469-2.911-4.317-2.375C1344.462,720.477,1343.394,722.396,1343.931,724.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152227848240350112620000016727226831650163080_",
    gradientUnits: "userSpaceOnUse",
    x1: 2452.7949,
    y1: 1320.1409,
    x2: 2533.9307,
    y2: 914.4611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2346.99,
    y: 1082.368,
    style: {
      fill: "url(#SVGID_00000152227848240350112620000016727226831650163080_)"
    },
    width: 287.273,
    height: 97.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017488741439930571220000011274645320467963796_",
    gradientUnits: "userSpaceOnUse",
    x1: 1511.7244,
    y1: 1459.8824,
    x2: 3041.7053,
    y2: 3668.1047,
    gradientTransform: "matrix(1 0 0 1 416.7324 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017488741439930571220000011274645320467963796_)"
    },
    d: "M2696.848,1197.116 c311.429,400.512,583.831,1119.875,349.247,1598.963c-19.529,39.884-71.235,66.277-128.785,66.277h-886.888 c-59.715,0-112.591-28.445-130.684-70.368c-41.827-96.923-108.443-284.686-112.313-504.488 c-2.872-163.1,82.185-320.389,236.341-437.471l186.15-141.382c25.17-19.117,39.079-44.782,38.699-71.413l-5.535-388.679 c-0.325-22.891,9.908-45.183,29.026-63.23l0,0c25.991-24.533,65.877-38.874,108.12-38.874h197.721 C2627.035,1146.451,2672.448,1165.738,2696.848,1197.116z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123403785151220874000000016430459391535511721_",
    gradientUnits: "userSpaceOnUse",
    x1: 2483.8528,
    y1: 1139.6998,
    x2: 2523.5928,
    y2: 715.8052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123403785151220874000000016430459391535511721_)"
    },
    d: "M2667.798,1130.983h-354.677 c-17.021,0-30.56-14.277-29.656-31.276l7.889-148.324c0.84-15.766,13.868-28.12,29.656-28.12h337.321 c15.667,0,28.639,12.171,29.637,27.806l9.468,148.324C2698.528,1116.505,2684.944,1130.983,2667.798,1130.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143589115463993890160000007408096441374004639_",
    gradientUnits: "userSpaceOnUse",
    x1: -187.7995,
    y1: -8692.5449,
    x2: -654.7222,
    y2: -7177.5273,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143589115463993890160000007408096441374004639_)"
    },
    d: "M1963.463,659.157 c4.748,87.87,12.034,402.973-115.127,549.299c-9.206,10.594-9.546,26.228-0.562,37.009l0,0 c9.712,11.653,26.866,13.641,38.952,4.474c58.817-44.616,217.048-180.547,245.498-370.326 c1.503-10.03,8.363-18.442,17.825-22.094l191.486-73.908c20.641-7.967,24.689-35.457,7.161-48.959 c-65.058-50.119-206.88-138.642-362.857-104.798C1972.198,632.813,1962.71,645.219,1963.463,659.157z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1844.251,1248.411c-10.422-12.499-10.162-30.573,0.62-42.973 c125.379-144.275,118.96-454.417,114-546.027c-0.876-16.275,10.058-30.599,26-34.052c23.308-5.062,47.442-7.625,71.729-7.625 c128.666,0,240.004,70.973,294.918,113.271c9.549,7.356,14.216,18.883,12.485,30.825c-1.74,11.977-9.518,21.725-20.799,26.076 l-191.487,73.914c-7.963,3.066-13.682,10.152-14.931,18.478c-28.352,189.137-182.371,324.079-247.27,373.31 c-5.773,4.379-12.648,6.689-19.881,6.689C1859.798,1260.298,1850.546,1255.964,1844.251,1248.411z M1986.823,634.352 c-11.501,2.499-19.387,12.822-18.753,24.557c5,92.491,11.402,405.68-116.248,552.573c-7.8,8.974-8.012,22.021-0.499,31.031 c7.873,9.459,22.813,11.213,32.628,3.759c64.005-48.556,215.879-181.538,243.727-367.339 c1.74-11.591,9.68-21.446,20.722-25.708l191.493-73.914c8.138-3.138,13.744-10.161,14.999-18.802 c1.25-8.605-2.113-16.905-8.992-22.201c-53.988-41.597-163.361-111.365-289.297-111.365 C2032.97,626.942,2009.492,629.433,1986.823,634.352z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165226177931226424710000000782679544805905301_",
    gradientUnits: "userSpaceOnUse",
    x1: -2709.4609,
    y1: 599.4467,
    x2: -3527.2495,
    y2: 593.606,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165226177931226424710000000782679544805905301_)"
    },
    d: "M1935.416,476.884v240.867 l-150.583-23.873c-17.784-2.819-31.078-17.843-31.713-35.838l-4.327-122.602c-0.686-19.41,13.514-36.152,32.776-38.645 L1935.416,476.884z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052064418963443288980000007003659448966258313_",
    gradientUnits: "userSpaceOnUse",
    x1: -524.4042,
    y1: -8796.2451,
    x2: -991.3256,
    y2: -7281.2319,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052064418963443288980000007003659448966258313_)"
    },
    d: "M2560.115,487.042l238.592,184.604 c21.765,16.84,36.283,41.351,40.593,68.531l5.531,34.885c9.174,57.866-29.446,112.499-87.058,123.155l-135.417,25.045H2346.99 l-42.207-125.466l-261.086-62.367l-108.281-17.678V476.884l556.177-12.406C2516.345,463.927,2540.535,471.893,2560.115,487.042z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088818566672965517320000006541478011456052895_",
    gradientUnits: "userSpaceOnUse",
    x1: 2839.7012,
    y1: 32.2009,
    x2: 2372.7791,
    y2: 1547.2172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088818566672965517320000006541478011456052895_)"
    },
    d: "M2497.796,557.515l63.665,282.192 c5.834,25.859,30.754,42.738,56.932,38.56l118.837-18.963c24.385-3.891,42.328-24.924,42.328-49.618v-38.5 c0-15.579-7.228-30.279-19.566-39.792L2517.86,544.712C2508.477,537.478,2495.188,545.957,2497.796,557.515z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053513183280726693190000007370868164864400538_",
    gradientUnits: "userSpaceOnUse",
    x1: -3341.3694,
    y1: -533.5427,
    x2: -3461.3523,
    y2: -43.6123,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053513183280726693190000007370868164864400538_)"
    },
    d: "M2642.841,1107.78h17.781 c0.582,0,1.053-0.471,1.053-1.053V949.728c0-0.582-0.472-1.053-1.053-1.053h-17.781c-0.582,0-1.053,0.472-1.053,1.053v156.999 C2641.787,1107.309,2642.259,1107.78,2642.841,1107.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069374049334107055260000006995251226462345389_",
    gradientUnits: "userSpaceOnUse",
    x1: -3297.6067,
    y1: -522.7516,
    x2: -3417.5898,
    y2: -32.8212,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069374049334107055260000006995251226462345389_)"
    },
    d: "M2596.435,1107.78h17.781 c0.582,0,1.053-0.472,1.053-1.053V949.728c0-0.582-0.471-1.053-1.053-1.053h-17.781c-0.582,0-1.053,0.471-1.053,1.053v156.999 C2595.382,1107.309,2595.854,1107.78,2596.435,1107.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028288567546237164790000017266751291440173502_",
    gradientUnits: "userSpaceOnUse",
    x1: -3253.843,
    y1: -511.9614,
    x2: -3373.8262,
    y2: -22.0312,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028288567546237164790000017266751291440173502_)"
    },
    d: "M2550.029,1107.78h17.781 c0.582,0,1.053-0.472,1.053-1.053V949.728c0-0.582-0.471-1.053-1.053-1.053h-17.781c-0.582,0-1.053,0.472-1.053,1.053v156.999 C2548.976,1107.309,2549.448,1107.78,2550.029,1107.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085934978833102532110000015162327019504632712_",
    gradientUnits: "userSpaceOnUse",
    x1: -3210.0806,
    y1: -501.1704,
    x2: -3330.0635,
    y2: -11.2401,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085934978833102532110000015162327019504632712_)"
    },
    d: "M2503.624,1107.78h17.781 c0.582,0,1.053-0.472,1.053-1.053V949.728c0-0.582-0.471-1.053-1.053-1.053h-17.781c-0.582,0-1.053,0.471-1.053,1.053v156.999 C2502.571,1107.309,2503.042,1107.78,2503.624,1107.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159442751371671558410000006534834457844422304_",
    gradientUnits: "userSpaceOnUse",
    x1: -3166.3174,
    y1: -490.3797,
    x2: -3286.3003,
    y2: -0.4503,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159442751371671558410000006534834457844422304_)"
    },
    d: "M2457.218,1107.78H2475 c0.582,0,1.053-0.472,1.053-1.053V949.728c0-0.582-0.472-1.053-1.053-1.053h-17.782c-0.582,0-1.053,0.472-1.053,1.053v156.999 C2456.165,1107.309,2456.636,1107.78,2457.218,1107.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050621727724469035730000014075698151692014011_",
    gradientUnits: "userSpaceOnUse",
    x1: -3122.5547,
    y1: -479.5883,
    x2: -3242.5376,
    y2: 10.3421,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050621727724469035730000014075698151692014011_)"
    },
    d: "M2410.813,1107.78h17.781 c0.582,0,1.053-0.471,1.053-1.053V949.728c0-0.582-0.471-1.053-1.053-1.053h-17.781c-0.582,0-1.053,0.471-1.053,1.053v156.999 C2409.76,1107.309,2410.231,1107.78,2410.813,1107.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146475009604596162030000007235303821477078946_",
    gradientUnits: "userSpaceOnUse",
    x1: -3078.7917,
    y1: -468.7985,
    x2: -3198.7749,
    y2: 21.1319,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146475009604596162030000007235303821477078946_)"
    },
    d: "M2364.407,1107.78h17.781 c0.582,0,1.053-0.472,1.053-1.053V949.728c0-0.582-0.471-1.053-1.053-1.053h-17.781c-0.582,0-1.053,0.471-1.053,1.053v156.999 C2363.354,1107.309,2363.826,1107.78,2364.407,1107.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037683996248353450020000004896748914423134626_",
    gradientUnits: "userSpaceOnUse",
    x1: -3035.0281,
    y1: -458.0085,
    x2: -3155.011,
    y2: 31.9218,
    gradientTransform: "matrix(-1 0 0 1 -1072.1127 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037683996248353450020000004896748914423134626_)"
    },
    d: "M2318.001,1107.78h17.781 c0.582,0,1.053-0.472,1.053-1.053V949.728c0-0.582-0.471-1.053-1.053-1.053h-17.781c-0.582,0-1.053,0.472-1.053,1.053v156.999 C2316.948,1107.309,2317.419,1107.78,2318.001,1107.78z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2823.737,1882.468c48.596,126.785,117.41,359.712,103.572,636.407 c-3.868,77.356-67.998,137.969-145.452,137.969h-634.552c-69.624,0-129.511-49.276-142.92-117.597l-52.91-269.586 c-10.592-53.968,10.113-109.28,53.528-143.039c124.083-96.484,393.532-285.643,655.313-335.042 C2729.656,1778.496,2798.483,1816.58,2823.737,1882.468z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2761.694,1964.083c40.761,106.343,98.48,301.715,86.873,533.797 c-3.245,64.884-57.036,115.724-122.001,115.724h-532.241c-58.398,0-108.63-41.331-119.878-98.636l-44.379-226.121 c-8.884-45.266,8.482-91.66,44.898-119.977c104.077-80.927,330.082-239.588,549.656-281.022 C2682.781,1876.875,2740.512,1908.818,2761.694,1964.083z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178175743850448400670000007463252587458108581_",
    gradientUnits: "userSpaceOnUse",
    x1: 1741.959,
    y1: 1380.0507,
    x2: 1682.3494,
    y2: 2363.6172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178175743850448400670000007463252587458108581_)"
    },
    d: "M1050.92,2147.775l-87.929,70.493 c-24.416,19.57-11.486,61.419,18.934,61.267l1445.415-8.521l-391.31-233.664h-675.768 C1248.829,2037.351,1140.36,2076.068,1050.92,2147.775z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092451874144641008580000007933003465912745384_",
    gradientUnits: "userSpaceOnUse",
    x1: 2661.4851,
    y1: -22.7296,
    x2: 2194.5642,
    y2: 1492.2821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092451874144641008580000007933003465912745384_)"
    },
    d: "M3203.778,2776.507 c-1.263-11.849-2.557-23.718-3.861-35.471c-13.37-120.612-74.924-228.877-168.606-296.26l-7.257-5.215 c-112.836-81.155-242.464-131.077-377.429-145.352l-219.285-23.194l-1445.415,8.521c-30.421,0.151-43.35-41.697-18.934-61.267 l87.929-70.493c89.44-71.708,197.909-110.425,309.342-110.425h675.768l-5.067-2.28c-40.605-18.272-84.164-27.68-128.158-27.68 H1266.42c-38.666,0-77.113,6.252-114.061,18.539l-478.645,191.101c-23.655,7.872-44.772,22.776-60.929,43.006l-98.875,123.813 c-20.58,25.771-31.9,58.655-31.9,92.672v201.762c0,53.4,175.04,235.854,175.04,235.854 c19.065,10.474,40.157,15.935,61.552,15.935h2150.251l228.371-16.051C3162.628,2909.42,3211.268,2846.749,3203.778,2776.507z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176764453318788944070000000796138277518181260_",
    gradientUnits: "userSpaceOnUse",
    x1: 3289.3933,
    y1: 2670.5156,
    x2: 2852.9714,
    y2: 3149.5957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176764453318788944070000000796138277518181260_)"
    },
    d: "M3196.184,2867.903h-6.835 c-13.309,0-24.097-11.639-24.097-25.997v-130.638c0-14.358,10.788-25.997,24.097-25.997l0,0c12.781,0,23.34,10.765,24.059,24.532 l6.835,130.637C3221.024,2855.35,3210.027,2867.903,3196.184,2867.903z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010294787304470357440000003835023065330892455_",
    gradientUnits: "userSpaceOnUse",
    x1: 3441.8545,
    y1: 2209.4939,
    x2: 3306.0764,
    y2: 2338.6489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010294787304470357440000003835023065330892455_)"
    },
    d: "M3111.385,2660.198h71.751 c-26.706-87.351-79.682-163.534-151.825-215.423l-7.257-5.215c-7.477-5.376-15.038-10.596-22.659-15.7 c14.648,55.127,32.708,130.719,44.599,181.452C3053.568,2637.623,3080.491,2660.198,3111.385,2660.198z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183971775043419149940000002732928935197007525_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.4281,
    y1: 2252.365,
    x2: 669.09,
    y2: 2475.4985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183971775043419149940000002732928935197007525_)"
    },
    d: "M673.714,2366.424v-149.394 c-23.655,7.872-44.772,22.776-60.929,43.006l-98.875,123.813c-17.181,21.514-27.796,48.01-30.871,75.96l134.971-23.038 C650.089,2431.301,673.714,2401.462,673.714,2366.424z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006667821457563508910000011327845007666699188_",
    gradientUnits: "userSpaceOnUse",
    x1: 2009.4924,
    y1: 2122.0364,
    x2: 2128.7126,
    y2: 2483.0085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006667821457563508910000011327845007666699188_)"
    },
    d: "M2189.835,2264.444l-50.82-53.273 c-21.177-22.199-47.83-37.353-76.774-43.65l-100.515-21.867c-27.584-6.001-53.985,14.86-57.004,45.042l-0.71,7.09 c-3.074,30.742,19.434,57.48,48.093,57.129l129.493-1.588c18.059-0.221,34.47,11.296,41.602,29.196l2.385,5.987 c3.166,7.945,10.413,13.095,18.429,13.095h31.842C2193.867,2301.604,2202.752,2277.984,2189.835,2264.444z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071523369605096444470000001393577002899073426_",
    gradientUnits: "userSpaceOnUse",
    x1: 2534.9126,
    y1: -61.7287,
    x2: 2067.99,
    y2: 1453.2886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071523369605096444470000001393577002899073426_)"
    },
    d: "M1669.138,2360.947h221.635 c17.288,0,29.474,18.535,23.48,36.028c-10.141,29.597-34.295,67.347-91.703,71.756c-51.631,3.966-116.71-27.574-165.796-57.542 C1634.502,2397.605,1643.569,2360.947,1669.138,2360.947z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062154560487659671500000003776527110439949997_",
    gradientUnits: "userSpaceOnUse",
    x1: 1507.5944,
    y1: 1649.2272,
    x2: 1322.1407,
    y2: 2112.8616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000062154560487659671500000003776527110439949997_)"
    },
    cx: 1016.556,
    cy: 2876.825,
    r: 292.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127028180687388275310000003720046225995490440_",
    gradientUnits: "userSpaceOnUse",
    x1: 1975.3577,
    y1: -234.1866,
    x2: 1508.4362,
    y2: 1280.8269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.42,
      fill: "url(#SVGID_00000127028180687388275310000003720046225995490440_)"
    },
    cx: 1016.556,
    cy: 2876.825,
    r: 237.606
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061432528306700200690000011233446818547738246_",
    gradientUnits: "userSpaceOnUse",
    x1: 3318.0227,
    y1: 1995.0474,
    x2: 3106.0754,
    y2: 2319.5916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000061432528306700200690000011233446818547738246_)"
    },
    cx: 2742.168,
    cy: 2876.825,
    r: 292.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008829663401746507660000009712655836551457192_",
    gradientUnits: "userSpaceOnUse",
    x1: 3551.2813,
    y1: 251.5055,
    x2: 3084.3599,
    y2: 1766.5194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.42,
      fill: "url(#SVGID_00000008829663401746507660000009712655836551457192_)"
    },
    cx: 2742.168,
    cy: 2876.825,
    r: 237.606
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.77,
      fill: "#FFFFFF"
    },
    d: "M2936.01,2962.025c-0.43,0-0.87-0.086-1.291-0.263 c-1.685-0.711-2.471-2.655-1.759-4.34c10.795-25.531,16.271-52.647,16.271-80.596c0-114.174-92.888-207.061-207.064-207.061 c-35.419,0-70.37,9.096-101.074,26.304c-1.607,0.894-3.619,0.32-4.508-1.271c-0.896-1.594-0.327-3.614,1.268-4.508 c31.694-17.76,67.763-27.148,104.314-27.148c117.826,0,213.687,95.857,213.687,213.684c0,28.84-5.65,56.824-16.795,83.177 C2938.526,2961.265,2937.3,2962.023,2936.01,2962.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "#FFFFFF"
    },
    d: "M1216.135,2962.025c-0.433,0-0.87-0.086-1.29-0.263 c-1.685-0.711-2.471-2.655-1.759-4.34c10.795-25.523,16.271-52.641,16.271-80.596c0-114.174-92.885-207.061-207.061-207.061 c-35.419,0-70.37,9.096-101.074,26.304c-1.607,0.894-3.619,0.32-4.508-1.271c-0.896-1.594-0.327-3.614,1.268-4.508 c31.694-17.76,67.763-27.148,104.315-27.148c117.826,0,213.684,95.857,213.684,213.684c0,28.848-5.65,56.832-16.795,83.177 C1218.651,2961.265,1217.425,2962.023,1216.135,2962.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    d: "M1370.584,2785.848c-1.559,0-2.949-1.104-3.25-2.692 c-26.073-137.092-104.237-224.306-232.315-259.224c-95.699-26.092-184.775-11.521-185.661-11.371 c-1.837,0.312-3.512-0.912-3.82-2.713c-0.304-1.803,0.912-3.512,2.713-3.816c0.906-0.154,91.424-14.961,188.507,11.51 c89.878,24.503,203.965,90.259,237.082,264.376c0.343,1.798-0.838,3.531-2.636,3.873 C1370.998,2785.83,1370.788,2785.848,1370.584,2785.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    d: "M2384.813,2830.428c-1.779,0-3.25-1.415-3.308-3.208 c-3.367-107.6,25.446-191.865,85.631-250.452c99.383-96.737,251.907-89.026,253.421-88.945c1.824,0.107,3.218,1.674,3.111,3.5 c-0.104,1.825-1.704,3.185-3.496,3.114c-1.514-0.094-151.202-7.59-248.453,87.113c-58.772,57.236-86.899,139.821-83.591,245.463 c0.055,1.827-1.381,3.357-3.208,3.413C2384.884,2830.428,2384.849,2830.428,2384.813,2830.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M991.155,2246.239c-1.151,0-2.27-0.601-2.882-1.674c-0.906-1.59-0.349-3.613,1.242-4.516 l195.974-111.505c55.639-31.66,118.877-49.001,182.886-50.149l224.796-4.034c1.779-0.042,3.338,1.425,3.37,3.252 c0.032,1.829-1.423,3.337-3.254,3.371l-224.796,4.034c-62.899,1.127-125.048,18.169-179.73,49.282l-195.974,111.505 C992.274,2246.1,991.711,2246.239,991.155,2246.239z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031893447953538462350000015621864903579390636_",
    gradientUnits: "userSpaceOnUse",
    x1: 1530.7446,
    y1: 2053.0989,
    x2: 2744.8164,
    y2: 2053.0989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031893447953538462350000015621864903579390636_)"
    },
    d: "M2620.048,2129.613 c-6.188-0.714-10.747-5.952-10.541-12.177c0.063-1.903,0.096-3.813,0.096-5.731c0-47.742-17.462-91.388-46.332-124.945 c-14.586-16.954-20.342-39.569-17.427-61.744c6.88-52.352-6.242-110.991-48.65-168.675c-4.27-5.808-9.501-10.886-15.427-14.991 c-85.922-59.528-174.873-56.593-240.319-18.011c-41.814,24.651-91.771,30.493-138.167,16.222 c-20.545-6.319-42.368-9.721-64.987-9.721c-17.618,0-34.752,2.067-51.176,5.967c-20.934,4.972-42.764-0.516-60.102-13.258 c-23.275-17.106-52.011-27.214-83.112-27.214c-77.612,0-150.592,152.039-155.203,156.829 c-8.285,8.605-21.219,11.294-31.809,5.767c-28.273-14.753-65.723-14.314-101.615,12.286c-0.981,0.727-1.873,1.62-2.599,2.602 c-52.359,70.781-3.006,148.007,64.383,148.007c4.854,0,9.614-0.403,14.247-1.176c14.863-2.48,30.023,3.805,37.993,16.593 c26.598,42.677,73.93,71.086,127.922,71.086c12.745,0,25.115-1.59,36.93-4.577c20.409-5.158,42.134-0.643,57.897,13.308 c38.946,34.469,90.146,55.4,146.245,55.4c10.892,0,21.595-0.8,32.06-2.334c18.558-2.722,37.452,1.795,52.66,12.773 c21.234,15.329,47.304,24.368,75.496,24.368c6.133,0,12.165-0.432,18.067-1.264c17.937-2.529,35.599,5.055,46.28,19.685 c34.876,47.767,91.275,78.814,154.95,78.814c4.818,0,9.594-0.178,14.323-0.529c18.084-1.34,35.411,8.138,42.858,24.673 c34.662,76.958,136.289,117.242,230.666,46.555c0.95-0.712,1.816-1.578,2.527-2.528 C2790.701,2261.417,2721.869,2141.359,2620.048,2129.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M2641.181,2168.572c15.502,5.37,29.725,14.482,41.333,26.231 c11.563,11.809,20.311,26.393,25.502,42.143c5.238,15.767,6.713,32.801,4.173,49.273c-2.453,16.483-8.865,32.33-18.276,46.071 c-18.955,27.439-51.043,45.57-84.415,46.727c-16.611,0.893-33.344-2.459-48.467-9.11c-15.093-6.756-28.609-16.942-39-29.639 c-0.613-0.746-0.505-1.846,0.241-2.459c0.72-0.593,1.778-0.507,2.401,0.172c21.373,23.441,53.226,36.706,84.479,34.322 c7.816-0.316,15.501-1.852,23.013-3.893c3.668-1.312,7.467-2.273,10.978-3.991l5.347-2.355l5.13-2.802l2.562-1.401l2.433-1.62 l4.868-3.229l4.575-3.635c1.55-1.183,3.047-2.423,4.42-3.811l4.253-4.003c1.35-1.399,2.621-2.877,3.938-4.311 c2.739-2.783,4.877-6.063,7.296-9.115c8.873-12.787,14.969-27.552,17.368-42.956c2.409-15.411,1.266-31.378-3.305-46.334 c-4.581-14.989-12.643-28.865-23.303-40.435c-10.668-11.581-24.052-20.642-38.761-26.566c-0.898-0.355-1.337-1.37-0.982-2.268 C2639.328,2168.71,2640.305,2168.275,2641.181,2168.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M2538.1,2008.413c5.388,5.306,10.134,11.248,14.421,17.507 c4.198,6.318,7.936,12.963,11.054,19.89c3.015,6.968,5.714,14.094,7.555,21.458c1.908,7.338,3.219,14.826,3.725,22.362 c0.065,0.966-0.665,1.8-1.631,1.865c-0.878,0.06-1.648-0.543-1.829-1.377c-1.57-7.213-3.387-14.328-5.631-21.294 c-2.31-6.941-4.782-13.823-7.908-20.427c-3.021-6.642-6.392-13.13-10.202-19.372c-3.719-6.301-7.879-12.344-12.202-18.332 c-0.569-0.785-0.395-1.881,0.389-2.449C2536.543,2007.734,2537.5,2007.825,2538.1,2008.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1692.271,2011.407c-11.15-11.721-25.795-19.349-41.197-21.897 c-7.69-1.353-15.593-1.336-23.27-0.246c-1.771,0.292-4.284,0.719-6.431,0.869c-2.232,0.195-4.479,0.231-6.717,0.099 c-4.474-0.212-8.928-0.942-13.235-2.193c-17.34-4.937-31.498-19.132-36.55-36.136c-2.534-8.456-3.183-17.509-1.456-26.045 c1.611-8.553,5.102-16.541,9.651-23.642c0.521-0.814,1.603-1.05,2.416-0.529c0.75,0.481,1.01,1.437,0.638,2.222l-0.015,0.033 c-3.456,7.309-6.191,14.939-6.933,22.774c-0.881,7.789-0.051,15.663,2.583,22.893c2.655,7.2,7.043,13.709,12.539,18.926 c5.565,5.16,12.308,8.993,19.566,11.089c3.638,1.019,7.395,1.601,11.171,1.746c1.89,0.079,3.778,0.091,5.666-0.054 c1.979-0.128,3.546-0.381,5.854-0.729c8.673-1.218,17.533-0.845,26.055,0.971c8.525,1.816,16.702,5.2,23.946,9.915 c7.227,4.737,13.547,10.773,18.425,17.724c0.555,0.792,0.364,1.884-0.428,2.441 C1693.829,2012.14,1692.859,2012.026,1692.271,2011.407z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1878.597,1894.907c-13.177,8.077-29.076,12.048-44.857,11.196 c-7.883-0.458-15.792-1.86-23.322-4.575c-7.496-2.756-14.686-6.49-21.173-11.304c-12.762-9.776-23.044-23.492-27.443-39.404 c-1.288-3.915-1.849-8-2.531-12.058c-0.273-4.101-0.68-8.212-0.338-12.33c0.414-8.212,2.132-16.441,5.361-24.04 c3.16-7.611,7.441-14.762,12.777-21.031c5.372-6.241,11.771-11.505,18.685-15.874c6.961-4.323,14.596-7.479,22.47-9.551 c7.882-2.172,16.079-2.674,24.145-2.568c16.17,0.601,32.141,6.055,44.934,15.665c12.824,9.494,22.559,23.07,26.601,38.102 c0.252,0.935-0.303,1.898-1.238,2.149c-0.839,0.227-1.7-0.198-2.05-0.963c-6.167-13.405-16.232-24.482-28.34-31.912 c-12.104-7.452-26.159-11.306-40.134-11.115c-13.983,0.029-27.74,4.06-39.436,11.335c-5.803,3.725-10.983,8.301-15.562,13.396 c-4.49,5.186-8.072,11.091-10.75,17.355c-2.766,6.253-4.147,13.026-4.647,19.82c-0.4,3.408-0.11,6.825-0.008,10.251 c0.51,3.379,0.844,6.806,1.853,10.094c3.381,13.325,11.451,25.371,22.164,34.393c21.586,18.124,54.353,22.359,81.193,9.888 c0.877-0.408,1.918-0.027,2.325,0.85C1879.654,1893.489,1879.346,1894.449,1878.597,1894.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1923.964,1913.687c-26.434,0-47.94-21.506-47.94-47.943c0-26.438,21.506-47.943,47.94-47.943 c26.437,0,47.943,21.506,47.943,47.943C1971.907,1892.181,1950.401,1913.687,1923.964,1913.687z M1923.964,1821.296 c-24.506,0-44.445,19.939-44.445,44.448c0,24.509,19.939,44.448,44.445,44.448c24.509,0,44.448-19.939,44.448-44.448 C1968.412,1841.234,1948.473,1821.296,1923.964,1821.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1953.113,1861.172c0,4.979-4.036,9.016-9.016,9.016c-4.979,0-9.016-4.037-9.016-9.016 c0-4.98,4.037-9.016,9.016-9.016C1949.077,1852.156,1953.113,1856.193,1953.113,1861.172z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2280.718,1813.578c8.749-27.757,29.622-51.728,56.323-64.944 c13.38-6.515,28.121-10.456,43.122-11.156c14.98-0.676,30.211,1.671,44.258,7.326c14.034,5.642,26.834,14.49,37.038,25.721 c4.96,5.72,9.547,11.826,13.094,18.538c1.942,3.263,3.416,6.761,4.932,10.229c0.765,1.732,1.267,3.567,1.909,5.344 c0.596,1.793,1.267,3.563,1.668,5.413c8.247,29.202,1.745,61.306-15.201,84.907c-0.565,0.787-1.661,0.966-2.447,0.401 c-0.704-0.505-0.915-1.451-0.548-2.203c12.257-25.253,15.616-54.199,7.294-79.903c-8.012-25.578-27.335-47.375-52.243-57.439 c-24.728-10.393-53.918-9.656-78.87,1.398c-12.538,5.425-23.971,13.461-33.796,23.178c-9.81,9.761-17.638,21.538-23.258,34.407 c-0.381,0.887-1.409,1.299-2.298,0.918C2280.869,1815.358,2280.462,1814.422,2280.718,1813.578z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2463.733,1968.368c-0.805,0-1.529-0.556-1.707-1.375c-0.205-0.942,0.393-1.874,1.334-2.079 c13.895-3.031,24.55-15.034,26.509-29.864c2.529-19.099-10.103-36.585-28.154-38.974 c-18.062-2.399-34.796,11.205-37.322,30.308c-0.792,5.973-0.113,12.048,1.962,17.574c0.342,0.905-0.116,1.911-1.021,2.249 c-0.894,0.348-1.908-0.116-2.249-1.021c-2.277-6.062-3.024-12.721-2.161-19.26c2.782-21.011,21.271-35.912,41.247-33.318 c19.963,2.645,33.943,21.891,31.165,42.899c-2.157,16.287-13.905,29.478-29.233,32.82 C2463.979,1968.354,2463.856,1968.368,2463.733,1968.368z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2347.287,2088.359c16.861-8.824,36.728-12.183,56.002-9.814 c9.609,1.341,19.179,3.715,28.175,7.686c8.951,4.033,17.332,9.361,24.883,15.763c14.846,13.035,25.902,30.861,30.005,50.577 c1.221,4.891,1.497,9.928,1.949,14.932c-0.06,5.021,0.049,10.062-0.761,15.038c-1.28,9.94-3.976,19.832-8.631,28.769 c-4.563,8.953-10.437,17.229-17.504,24.332c-7.148,7.005-15.247,13.002-24.083,17.61c-17.734,9.085-38.04,12.838-57.617,10.625 c-19.598-1.978-38.483-9.965-53.37-22.533c-14.864-12.54-25.803-29.69-29.901-48.348c-0.208-0.944,0.389-1.877,1.334-2.085 c0.875-0.193,1.74,0.307,2.028,1.133c6.032,17.265,17.367,32.208,31.769,42.674c14.323,10.606,31.638,16.678,49.153,17.804 c17.525,1.094,35.217-2.531,50.454-10.858c7.533-4.27,14.551-9.401,20.646-15.507c6.029-6.167,10.971-13.301,14.798-20.946 c3.927-7.618,6.343-15.946,7.485-24.419c0.754-4.234,0.653-8.531,0.779-12.818c-0.376-4.265-0.556-8.562-1.544-12.748 c-1.634-8.391-4.415-16.682-8.808-24.148c-4.313-7.49-9.687-14.405-15.954-20.497c-25.401-24.21-65.563-32.17-99.859-19.031 c-0.903,0.346-1.915-0.104-2.261-1.007C2346.133,2089.702,2346.51,2088.765,2347.287,2088.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.786,2178.832c-1.396,0-2.792-0.048-4.198-0.147c-15.669-1.096-29.977-8.229-40.285-20.09 c-10.307-11.857-15.379-27.018-14.283-42.69c1.099-15.673,8.232-29.977,20.089-40.285 c11.861-10.304,27.014-15.386,42.691-14.28c15.669,1.095,29.977,8.229,40.284,20.089 c10.307,11.857,15.379,27.018,14.284,42.691c-1.099,15.672-8.232,29.977-20.089,40.284 C2316.483,2173.787,2302.951,2178.832,2288.786,2178.832z M2288.609,2064.688c-13.325,0-26.052,4.744-36.206,13.57 c-11.154,9.693-17.864,23.151-18.895,37.892c-1.034,14.741,3.737,29.001,13.434,40.155 c9.693,11.151,23.151,17.861,37.892,18.891c14.693,1.038,28.997-3.734,40.151-13.43c11.154-9.693,17.865-23.151,18.895-37.892 c1.034-14.741-3.737-29.001-13.434-40.155c-9.693-11.15-23.151-17.861-37.892-18.892 C2291.237,2064.736,2289.919,2064.688,2288.609,2064.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2252.378,2123.131c0.43-6.136,5.752-10.763,11.889-10.334 c6.136,0.43,10.763,5.752,10.333,11.889c-0.43,6.136-5.752,10.763-11.889,10.333S2251.948,2129.268,2252.378,2123.131z"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.49,
      fill: "#FFFFFF"
    },
    cx: 2701.526,
    cy: 2427.539,
    r: 17.711
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1347.85,1940.492c-26.564,0-48.175-21.612-48.175-48.179c0-26.564,21.612-48.176,48.175-48.176 c26.568,0,48.179,21.611,48.179,48.176C1396.029,1918.88,1374.417,1940.492,1347.85,1940.492z M1347.85,1851.128 c-22.71,0-41.186,18.475-41.186,41.186c0,22.71,18.475,41.189,41.186,41.189c22.711,0,41.189-18.478,41.189-41.189 C1389.039,1869.603,1370.561,1851.128,1347.85,1851.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2231.744,1815.019c-16.963,0-30.765-13.802-30.765-30.765c0-16.966,13.802-30.769,30.765-30.769 c16.966,0,30.769,13.802,30.769,30.769C2262.514,1801.217,2248.711,1815.019,2231.744,1815.019z M2231.744,1760.475 c-13.109,0-23.775,10.666-23.775,23.779c0,13.109,10.666,23.776,23.775,23.776c13.113,0,23.779-10.666,23.779-23.776 C2255.524,1771.141,2244.858,1760.475,2231.744,1760.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.49,
      fill: "#FFFFFF"
    },
    d: "M2064.487,1666.724c-69.453,0-125.96-56.507-125.96-125.959 c0-69.453,56.507-125.956,125.96-125.956s125.956,56.503,125.956,125.956C2190.442,1610.218,2133.939,1666.724,2064.487,1666.724 z M2064.487,1421.799c-65.599,0-118.97,53.367-118.97,118.966c0,65.599,53.37,118.969,118.97,118.969 s118.966-53.37,118.966-118.969C2183.452,1475.166,2130.086,1421.799,2064.487,1421.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1704.965,1131.917c-42.38,0-76.856-34.476-76.856-76.856s34.476-76.856,76.856-76.856 s76.856,34.476,76.856,76.856S1747.346,1131.917,1704.965,1131.917z M1704.965,986.825c-37.624,0-68.236,30.612-68.236,68.236 s30.612,68.236,68.236,68.236c37.624,0,68.236-30.612,68.236-68.236S1742.589,986.825,1704.965,986.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1461.406,1601.739c-96.095,0-174.271-78.18-174.271-174.275 c0-96.095,78.177-174.271,174.271-174.271c96.095,0,174.271,78.177,174.271,174.271 C1635.677,1523.559,1557.501,1601.739,1461.406,1601.739z M1461.406,1260.183c-92.238,0-167.281,75.043-167.281,167.281 c0,92.242,75.043,167.285,167.281,167.285s167.281-75.043,167.281-167.285 C1628.688,1335.226,1553.645,1260.183,1461.406,1260.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.49,
      fill: "#FFFFFF"
    },
    d: "M2070.986,1428.298c-62.114,0-112.466,50.353-112.466,112.467 c0,62.113,50.353,112.466,112.466,112.466c62.114,0,112.467-50.353,112.467-112.466 C2183.452,1478.651,2133.1,1428.298,2070.986,1428.298z M2118.616,1527.239c-10.932,3.548-17.894-10.364-23.751-28.411 c-5.858-18.048-8.393-33.397,2.54-36.945c10.932-3.548,31.191,6.048,37.049,24.096 C2140.311,1504.027,2129.548,1523.691,2118.616,1527.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.49,
      fill: "#FFFFFF"
    },
    d: "M1475.493,1272.227c-77.956,0-141.151,63.196-141.151,141.152 c0,77.955,63.195,141.15,141.151,141.15c77.956,0,141.151-63.196,141.151-141.15 C1616.644,1335.423,1553.449,1272.227,1475.493,1272.227z M1535.272,1396.404c-13.72,4.453-22.458-13.007-29.809-35.656 c-7.351-22.652-10.533-41.915,3.188-46.368c13.72-4.453,39.146,7.59,46.498,30.242 C1562.499,1367.271,1548.992,1391.951,1535.272,1396.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.49,
      fill: "#FFFFFF"
    },
    d: "M1714.249,994.216c-29.486,0-53.388,23.902-53.388,53.388 c0,29.485,23.902,53.387,53.388,53.387c29.485,0,53.387-23.902,53.387-53.387 C1767.636,1018.118,1743.734,994.216,1714.249,994.216z M1736.859,1041.183c-5.19,1.684-8.495-4.92-11.275-13.486 c-2.781-8.567-3.984-15.853,1.205-17.537c5.19-1.684,14.807,2.871,17.587,11.438 C1747.157,1030.164,1742.049,1039.499,1736.859,1041.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2587.021,1434.81c-34.366,0-62.323-27.957-62.323-62.323c0-34.366,27.956-62.323,62.323-62.323 c34.367,0,62.323,27.956,62.323,62.323C2649.344,1406.853,2621.388,1434.81,2587.021,1434.81z M2587.021,1317.154 c-30.509,0-55.333,24.823-55.333,55.333c0,30.509,24.823,55.333,55.333,55.333c30.51,0,55.333-24.823,55.333-55.333 C2642.354,1341.977,2617.531,1317.154,2587.021,1317.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2594.55,1323.147c-23.91,0-43.292,19.382-43.292,43.292c0,23.909,19.382,43.292,43.292,43.292 c23.909,0,43.292-19.383,43.292-43.292C2637.842,1342.53,2618.459,1323.147,2594.55,1323.147z M2612.885,1361.233 c-4.208,1.366-6.888-3.99-9.143-10.936c-2.255-6.947-3.23-12.856,0.977-14.221c4.208-1.366,12.007,2.328,14.261,9.275 C2621.235,1352.298,2617.092,1359.867,2612.885,1361.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2270.257,1911.202 2240.285,1758.731 1858.713,2091.656 1866.151,2104.369  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1559.786,2161.417c0,0,4.587,63.264,62.331,96.974c57.745,33.711,128.524-41.871,141.289-86.851 l36.2,19.052c0,0-76.587,287.508-295.409,96.039L1559.786,2161.417z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169551962966428832970000004848032058365867436_",
    gradientUnits: "userSpaceOnUse",
    x1: 9853.1797,
    y1: 3162.9351,
    x2: 10008.0527,
    y2: 3162.9351,
    gradientTransform: "matrix(1 0 0 1 -8515.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169551962966428832970000004848032058365867436_)"
    },
    d: "M1395.646,3194.161 c36.064,1.659,70.972,0.617,94.279-0.581c-21.222-15.105-70.111-47.968-111.021-61.051l-28.083-1.68 c0,0-9.516,14.472-12.911,47.592C1342.564,3184.247,1356.168,3192.344,1395.646,3194.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015320702790026037340000009905596807185268669_",
    gradientUnits: "userSpaceOnUse",
    x1: 1485.2535,
    y1: 2483.4917,
    x2: 1398.2865,
    y2: 3357.1182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015320702790026037340000009905596807185268669_)"
    },
    d: "M1490.215,3193.785 c-0.093-0.066-0.197-0.138-0.29-0.206c-23.308,1.198-58.215,2.24-94.279,0.581c-39.478-1.816-53.082-9.914-57.736-15.721 c-0.157,1.525-0.316,3.041-0.446,4.646c-0.583,7.268,4.811,13.648,12.082,14.199c29.536,2.233,102.767,7.29,138.083,5.437 C1492.285,3202.479,1494.014,3196.493,1490.215,3193.785z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051357598802369141270000015884862135132654270_",
    gradientUnits: "userSpaceOnUse",
    x1: 9578.3848,
    y1: 3158.0208,
    x2: 9650.9023,
    y2: 3158.0208,
    gradientTransform: "matrix(1 0 0 1 -8515.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051357598802369141270000015884862135132654270_)"
    },
    d: "M1134.972,3184.509 c-2.641-16.93-6.876-41.406-10.148-47.664c-5.134-9.816-22.707,0-22.707,0s-3.355-22.145-9.033-12.556 c-3.619,6.112-22.609,51.399-29.392,63.207c-0.781,1.357-1.105,2.803-1.064,4.203l70.365,2.463 C1134.714,3191.4,1135.522,3188.034,1134.972,3184.509z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013894326925022199570000018420418943475451572_",
    gradientUnits: "userSpaceOnUse",
    x1: 1121.8882,
    y1: 2494.6946,
    x2: 1094.2173,
    y2: 3297.1638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013894326925022199570000018420418943475451572_)"
    },
    d: "M1062.629,3191.698 c0.118,4.02,3.303,7.665,7.798,7.789l50.129,1.379c5.297,0.147,9.883-2.606,12.438-6.705L1062.629,3191.698z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076593188779248236670000017812084960335175552_",
    gradientUnits: "userSpaceOnUse",
    x1: 9540.4893,
    y1: 2795.2598,
    x2: 9587.541,
    y2: 2795.2598,
    gradientTransform: "matrix(0.9878 0.1556 -0.1556 0.9878 -7892.0474 -1149.0093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076593188779248236670000017812084960335175552_)"
    },
    d: "M1148.68,3071.613 c-0.916,1.912-16.754,44.039-23.695,62.529c-1.919,5.111-7.26,8.069-12.603,6.952c-2.919-0.61-6.298-1.414-9.814-2.443 c-6.237-1.827-10.248-7.907-9.483-14.361c1.999-16.839,6.746-49.027,14.855-60.513 C1119.123,3047.931,1148.68,3071.613,1148.68,3071.613z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173133599219972176050000017325601708037130932_",
    gradientUnits: "userSpaceOnUse",
    x1: 9861.0576,
    y1: 3110.2488,
    x2: 9900.2734,
    y2: 3110.2488,
    gradientTransform: "matrix(1 0 0 1 -8515.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173133599219972176050000017325601708037130932_)"
    },
    d: "M1345.298,3093.194 c3.899-0.125-1.556,20.135,4.344,40.047c1.331,4.491,4.689,8.016,9.373,8.076c3.036,0.039,6.631-0.019,10.284-0.312 c5.493-0.44,9.906-4.702,10.416-10.189l4.799-51.647L1345.298,3093.194z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145768211154382000220000004249716241103685027_",
    gradientUnits: "userSpaceOnUse",
    x1: 1802.8319,
    y1: 1759.4493,
    x2: 1217.7792,
    y2: 3063.9597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145768211154382000220000004249716241103685027_)"
    },
    d: "M1454.377,2544.185 c-1.741,8.473-63.177,366.818-66.905,552.244c-0.063,3.109-2.351,5.717-5.43,6.146c-7.8,1.087-22.988,2.486-37.716-0.246 c-2.017-0.374-3.537-2.035-3.664-4.082c-2.147-34.555-19.415-326.713,1.733-464.246c0,0-174.684,367.645-201.162,469.019 c-0.644,2.466-2.908,4.125-5.454,3.991c-7.482-0.396-23.04-1.741-35.393-6.289c-4.428-1.63-6.95-6.283-5.832-10.867 c14.794-60.668,118.472-478.654,188.867-570.747L1454.377,2544.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1342.396,2636.294c-0.579,0-1.157-0.217-1.603-0.654c-0.906-0.884-0.922-2.337-0.036-3.242 l23.391-23.919c0.885-0.907,2.338-0.92,3.243-0.036c0.905,0.885,0.921,2.338,0.036,3.243l-23.391,23.919 C1343.586,2636.064,1342.991,2636.294,1342.396,2636.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1552.886,2118.496c-51.122-13.406-151.896-35.577-220.516-23.221l-85.513,458.325 c-1.235,6.622,3.831,12.744,10.567,12.768l184.643,0.666c6.413,0.023,12.14-4.013,14.276-10.061l107.011-303.028 C1563.354,2253.945,1590.986,2128.487,1552.886,2118.496z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064344639853765812760000001405811124629939602_",
    gradientUnits: "userSpaceOnUse",
    x1: 9978.4453,
    y1: 2150.2004,
    x2: 9996.7891,
    y2: 2037.0803,
    gradientTransform: "matrix(1 0 0 1 -8515.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064344639853765812760000001405811124629939602_)"
    },
    d: "M1444.702,1995.506 c0,0-13.619,81.257-15.445,106.791c0,0,65.766,18.164,82.935,8.425l-2.152-98.291L1444.702,1995.506z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070823679191842991450000015055854165251246254_",
    gradientUnits: "userSpaceOnUse",
    x1: 10038.9404,
    y1: 1964.8145,
    x2: 9913.9668,
    y2: 2060.4387,
    gradientTransform: "matrix(1 0 0 1 -8515.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070823679191842991450000015055854165251246254_)"
    },
    d: "M1518.599,1920.61 c0,0,21.861,50.219,23.329,76.578c1.469,26.359,7.148,43.461-23.329,48.769c-30.477,5.308-56.151-9.874-70.061-36.131 c0,0-21.793-40.457-16.903-57.026C1436.523,1936.233,1518.599,1920.61,1518.599,1920.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017482521705397643810000006438155541027361445_",
    gradientUnits: "userSpaceOnUse",
    x1: 9987.1699,
    y1: 1863.8828,
    x2: 9981.918,
    y2: 2019.6836,
    gradientTransform: "matrix(1 0 0 1 -8515.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017482521705397643810000006438155541027361445_)"
    },
    d: "M1458.953,1990.949h3.853 c0,0-15.875-32.562-1.927-38.282c13.949-5.72,69.202-16.988,81.123-36.593c11.492-18.901,1.244-43.315-14.091-50.147 c-0.97-0.432-2.115,0.024-2.61,0.963l-1.27,2.403c-0.87,1.646-3.302,1.397-3.819-0.392l0,0 c-0.491-1.697-2.778-2.067-3.711-0.568c-3.649,5.863-13.531,15.397-40.033,20.288c-37.605,6.94-62.465,22.16-63.076,48.148 c-0.039,1.647-1.799,2.554-3.206,1.697c-2.776-1.691-7.219-2.486-13.156,2.507c-10.325,8.683-6.1,31.205,16.536,49.732 c1.075,0.88,1.066,2.56-0.098,3.318c-4.104,2.672-10.219,9.028,5.631,17.5c16.214,8.667,25.81,7.722,29.431,6.795 c0.974-0.249,1.63-1.137,1.567-2.141l-1.422-23.031c-0.074-1.191,0.872-2.198,2.066-2.198H1458.953z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166660796365035030590000008254774643083669384_",
    gradientUnits: "userSpaceOnUse",
    x1: 10023.4395,
    y1: 1944.5546,
    x2: 9898.4648,
    y2: 2040.1792,
    gradientTransform: "matrix(1 0 0 1 -8515.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166660796365035030590000008254774643083669384_)"
    },
    d: "M1459.9,1995.768 c0,0-8.34-32.079-22.723-23.084c-14.383,8.994,7.464,35.944,19.026,37.143L1459.9,1995.768z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1332.369,2095.277l35.71,135.78c0,0-67.934,36.928-58.131,81.818 c2.79,12.781,17.65,19.607,37.46,22.853c-12.676,13.637-27.505,38.023-22.986,75.109 c-53.967-0.461-100.007-21.947-107.981-86.701C1198.611,2179.338,1332.369,2095.277,1332.369,2095.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1347.41,2338.603c1.385,0,2.603-0.999,2.837-2.409c0.255-1.567-0.806-3.05-2.373-3.303 c-21.065-3.454-32.879-10.396-35.117-20.629c-9.236-42.297,56.036-78.316,56.695-78.675c1.396-0.758,1.913-2.505,1.154-3.904 c-0.761-1.393-2.505-1.91-3.901-1.151c-2.851,1.551-69.715,38.49-59.565,84.955c2.789,12.772,16.181,21.208,39.801,25.078 C1347.099,2338.592,1347.256,2338.603,1347.41,2338.603z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162330521237707885030000012356369769476847004_",
    gradientUnits: "userSpaceOnUse",
    x1: -1247.1569,
    y1: 2298.6855,
    x2: -988.8663,
    y2: 2417.7488,
    gradientTransform: "matrix(-1 0 0 1 285.6383 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162330521237707885030000012356369769476847004_)"
    },
    d: "M1347.408,2335.728 c49.786,8.161,130.924-6.363,130.924-6.363l33.86,23.039c-27.692,21.396-114.95,59.06-187.77,58.434 C1319.903,2373.751,1334.732,2349.365,1347.408,2335.728z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118362408496318676180000000927886356983498393_",
    gradientUnits: "userSpaceOnUse",
    x1: -1830.3136,
    y1: 3558.3113,
    x2: -1614.7418,
    y2: 3558.3113,
    gradientTransform: "matrix(-0.8631 0.505 0.505 0.8631 -1494.0055 -62.7607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118362408496318676180000000927886356983498393_)"
    },
    d: "M1708.41,2213.11l164.907-96.495 c11.212-6.56,15.965-21.049,9.484-32.307c-0.078-0.135-0.156-0.269-0.236-0.403c-6.64-11.165-21.599-14.118-32.811-7.558 l-164.907,96.496L1708.41,2213.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088837945876630939730000002741979756280233866_",
    gradientUnits: "userSpaceOnUse",
    x1: -1647.9777,
    y1: 3597.1614,
    x2: -1399.2878,
    y2: 3597.1614,
    gradientTransform: "matrix(-0.8631 0.505 0.505 0.8631 -1494.0055 -62.7607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088837945876630939730000002741979756280233866_)"
    },
    d: "M1564.672,2387.226l201.414-117.858 c5.655-3.309,7.557-10.575,4.248-16.23l-56.806-97.079l-211.654,123.849c-1.647,0.964-2.201,3.08-1.237,4.727l59.308,101.354 C1560.908,2387.636,1563.025,2388.19,1564.672,2387.226z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096780739110945309440000004611786563449196956_",
    gradientUnits: "userSpaceOnUse",
    x1: -1251.7014,
    y1: 2308.5447,
    x2: -993.4116,
    y2: 2427.6074,
    gradientTransform: "matrix(-1 0 0 1 285.6383 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096780739110945309440000004611786563449196956_)"
    },
    d: "M1476.512,2338.603l1.821-9.239 c0,0,11.622-35.262,39.468-45.971c27.845-10.709,45.609,0.333,48.97,18.576c3.36,18.244-15.843,31.207-33.607,31.687 C1515.399,2334.136,1513.959,2383.879,1476.512,2338.603z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091012811026958681690000002280606400652213437_",
    gradientUnits: "userSpaceOnUse",
    x1: -1521.5997,
    y1: 2156.7292,
    x2: -1331.431,
    y2: 2244.3906,
    gradientTransform: "matrix(-1 0 0 1 285.6383 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091012811026958681690000002280606400652213437_)"
    },
    d: "M1803.576,2125.563 c9.403-4.031,19.531,3.93,18.147,14.067c-1.328,9.732-3.847,22.308-8.615,34.135c-9.702,24.06-14.026,25.97-49.701,7.164 l21.883-12.804C1785.29,2168.124,1779.665,2135.816,1803.576,2125.563z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116229841176933329400000008682558741804725133_",
    gradientUnits: "userSpaceOnUse",
    x1: 2104.5042,
    y1: 2582.1272,
    x2: 1763.4014,
    y2: 2654.9844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116229841176933329400000008682558741804725133_)"
    },
    d: "M985.438,3089.687h309.97 c48.441,0,90.518-27.605,109.808-72.04c19.29-44.435,10.729-94.026-22.351-129.411l-85.367-91.334 c-36.536-39.094-53.504-91.931-46.55-144.962c6.979-53.258,37.224-100.194,82.979-128.78l238.664-144.053 c4.977-2.999,6.574-9.465,3.57-14.437c-2.994-4.976-9.455-6.579-14.437-3.569l-238.803,144.135 c-51.245,32.011-85.028,84.453-92.834,143.966c-7.771,59.292,11.196,118.359,52.046,162.059l85.367,91.335 c27.266,29.171,34.323,70.047,18.422,106.675c-15.9,36.628-50.582,59.38-90.513,59.38h-309.97 c-5.809,0-10.518,4.709-10.518,10.518C974.92,3084.977,979.629,3089.687,985.438,3089.687z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049904458019478203410000001403106569444373164_",
    gradientUnits: "userSpaceOnUse",
    x1: -100.6686,
    y1: 2639.9795,
    x2: -714.6921,
    y2: 4018.3997,
    gradientTransform: "matrix(-1 0 0 1 285.6383 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049904458019478203410000001403106569444373164_)"
    },
    d: "M484.38,3111.674h50.843v-394.058 H484.38c-1.945,0-3.522,1.577-3.522,3.522v387.014C480.858,3110.097,482.435,3111.674,484.38,3111.674z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031899099697128762570000002481040811255004053_",
    gradientUnits: "userSpaceOnUse",
    x1: 1140.0209,
    y1: 2385.3184,
    x2: 518.5116,
    y2: 3320.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031899099697128762570000002481040811255004053_)"
    },
    d: "M497.936,2748.165v332.956 c0,16.865,17.579,28.455,34.443,28.455h515.513c16.864,0,29.587-11.59,29.587-28.455v-157.032 c0-114.042-91.469-205.291-205.51-205.291h-339.59C515.515,2718.798,497.936,2731.302,497.936,2748.165z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074440981189092134480000006110547189019293855_",
    gradientUnits: "userSpaceOnUse",
    x1: 1075.0446,
    y1: 2620.5894,
    x2: 775.8243,
    y2: 3093.0432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074440981189092134480000006110547189019293855_)"
    },
    d: "M799.298,2718.798v197.412 c0,16.958,23.506,37.717,40.463,37.717h237.718v-29.838c0-114.042-91.469-205.291-205.51-205.291H799.298z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155845082332180069050000009419135802171874453_",
    gradientUnits: "userSpaceOnUse",
    x1: -507.8481,
    y1: 2979.636,
    x2: -802.7169,
    y2: 3641.5859,
    gradientTransform: "matrix(-1 0 0 1 285.6383 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000155845082332180069050000009419135802171874453_)"
    },
    cx: 852.303,
    cy: 3111.674,
    r: 91.449
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106120902081782442080000008508408160256368800_",
    gradientUnits: "userSpaceOnUse",
    x1: -588.0781,
    y1: 3145.2214,
    x2: -532.8202,
    y2: 3058.6506,
    gradientTransform: "matrix(-1 0 0 1 285.6383 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000106120902081782442080000008508408160256368800_)"
    },
    cx: 852.303,
    cy: 3111.674,
    r: 74.886
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1052.34,2925.17c0.104,0,0.211-0.006,0.317-0.017c1.578-0.174,2.719-1.595,2.544-3.173 c-19.394-176.548-201.018-181.468-202.852-181.496c-1.488-0.006-2.892,1.247-2.921,2.83c-0.025,1.584,1.241,2.892,2.828,2.921 c1.784,0.028,178.396,4.92,197.228,176.373C1049.647,2924.08,1050.89,2925.17,1052.34,2925.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084513420125002661680000009200895122358448816_",
    gradientUnits: "userSpaceOnUse",
    x1: -942.1404,
    y1: 2722.822,
    x2: -1351.0087,
    y2: 3640.6892,
    gradientTransform: "matrix(-1 0 0 1 -358.5211 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084513420125002661680000009200895122358448816_)"
    },
    d: "M680.078,2783.375 c0-8.23-6.672-14.903-14.903-14.903l0,0c-8.23,0-14.903,6.672-14.903,14.903v245.064c0,8.231,6.672,14.903,14.903,14.903l0,0 c8.231,0,14.903-6.672,14.903-14.903V2783.375z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183233220250613414910000002793442509833521301_",
    gradientUnits: "userSpaceOnUse",
    x1: -875.907,
    y1: 2722.822,
    x2: -1284.7751,
    y2: 3640.6892,
    gradientTransform: "matrix(-1 0 0 1 -358.5211 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183233220250613414910000002793442509833521301_)"
    },
    d: "M613.845,2783.375 c0-8.23-6.672-14.903-14.903-14.903l0,0c-8.23,0-14.902,6.672-14.902,14.903v245.064c0,8.231,6.672,14.903,14.902,14.903l0,0 c8.231,0,14.903-6.672,14.903-14.903V2783.375z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2289.025,1674.457c0,0-20.282-54.872-79.123-34.072c-31.522,11.143-40.906,32.138-42.826,49.232 c-1.442,12.845-9.324,24.104-20.517,30.568c-10.916,6.304-22.056,21.08-24.046,54.721c-2.704,45.712,25.729,73.25,45.318,86.667 c8.608,5.896,13.279,15.635,13.769,26.058c0.408,8.695,4.983,19.787,21.077,30.285c9.1,5.937,14.184,16.317,13.868,27.178 c-0.724,24.864,7.842,67.003,71.469,77.203c91.732,14.703,209.106-29.254,163.088-142.134 c-21.116-51.796-50.421-70.055-75.954-74.648c-21.295-3.831-35.773-23.546-32.881-44.989 C2346.042,1732.531,2337.291,1699.013,2289.025,1674.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1908.296,2075.35c0.108,0,0.216-0.026,0.319-0.082 c105.643-58.189,214.48-113.824,323.497-165.362c0.329-0.154,0.467-0.55,0.313-0.878c-0.159-0.323-0.55-0.462-0.878-0.313 c-109.038,51.548-217.901,107.199-323.57,165.403c-0.318,0.175-0.431,0.575-0.257,0.894 C1907.839,2075.227,1908.065,2075.35,1908.296,2075.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1905.825,2068.37c0.113,0,0.226-0.025,0.329-0.087 c147.602-84.858,183.958-106.788,188.462-110.24c0.288-0.221,0.344-0.637,0.123-0.924c-0.226-0.293-0.637-0.339-0.925-0.124 c-4.473,3.431-40.773,25.325-188.318,110.147c-0.313,0.18-0.421,0.585-0.241,0.898 C1905.379,2068.252,1905.6,2068.37,1905.825,2068.37z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService6);
export default __webpack_public_path__ + "static/media/service6.a845fc27f13c5aad96c68b98a74e726c.svg";
export { ForwardRef as ReactComponent };